var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "8 7.49 194 194.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,64.4922a4.00018,4.00018,0,0,1-4-4v-48a4.00018,4.00018,0,0,1,4-4H61a4,4,0,0,1,0,8H17v44A4.00018,4.00018,0,0,1,13,64.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61,200.5078H13a4.00018,4.00018,0,0,1-4-4v-48a4,4,0,0,1,8,0v44H61a4,4,0,0,1,0,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197,64.4922a4.00018,4.00018,0,0,1-4-4v-44H149a4,4,0,0,1,0-8h48a4.00018,4.00018,0,0,1,4,4v48A4.00018,4.00018,0,0,1,197,64.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197,200.5078H149a4,4,0,0,1,0-8h44v-44a4,4,0,1,1,8,0v48A4.00018,4.00018,0,0,1,197,200.5078Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49,
    y: 48.4922,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77,80.4922H37a4.00018,4.00018,0,0,1-4-4v-40a4.00018,4.00018,0,0,1,4-4H77a4.00018,4.00018,0,0,1,4,4v40A4.00018,4.00018,0,0,1,77,80.4922Zm-36-8H73v-32H41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49,
    y: 144.4922,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77,176.4922H37a4.00018,4.00018,0,0,1-4-4v-40a4.00018,4.00018,0,0,1,4-4H77a4.00018,4.00018,0,0,1,4,4v40A4.00018,4.00018,0,0,1,77,176.4922Zm-36-8H73v-32H41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145,
    y: 48.4922,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173,80.4922H133a4.00018,4.00018,0,0,1-4-4v-40a4.00018,4.00018,0,0,1,4-4h40a4.00018,4.00018,0,0,1,4,4v40A4.00018,4.00018,0,0,1,173,80.4922Zm-36-8h32v-32H137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37,120.4922a4.00018,4.00018,0,0,1-4-4v-16a4.00018,4.00018,0,0,1,4-4H53a4,4,0,0,1,0,8H41v12A4.00018,4.00018,0,0,1,37,120.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77,120.4922H61a4,4,0,0,1,0-8H73v-12a4,4,0,0,1,8,0v16A4.00018,4.00018,0,0,1,77,120.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93,48.4922a4.00018,4.00018,0,0,1-4-4v-8a4,4,0,0,1,8,0v8A4.00018,4.00018,0,0,1,93,48.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109,64.4922H93a4,4,0,0,1,0-8h12v-12a4.00018,4.00018,0,0,1,4-4h8a4,4,0,0,1,0,8h-4v12A4.00018,4.00018,0,0,1,109,64.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101,104.4922a4.00018,4.00018,0,0,1-4-4v-24a4.00018,4.00018,0,0,1,4-4h16a4,4,0,0,1,0,8H105v20A4.00018,4.00018,0,0,1,101,104.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109,104.4922H93a4,4,0,0,1,0-8h16a4,4,0,0,1,0,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125,104.4922a4.00018,4.00018,0,0,1-4-4v-8a4,4,0,0,1,8,0v8A4.00018,4.00018,0,0,1,125,104.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93,152.4922a4.00018,4.00018,0,0,1-4-4v-8a4.00018,4.00018,0,0,1,4-4h16a4,4,0,0,1,0,8H97v4A4.00018,4.00018,0,0,1,93,152.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109,152.4922a4.00018,4.00018,0,0,1-4-4v-24a4,4,0,0,1,8,0v24A4.00018,4.00018,0,0,1,109,152.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125,176.4922H101a4,4,0,0,1,0-8h20v-12a4.00018,4.00018,0,0,1,4-4h4v-4a4,4,0,0,1,8,0v8a4.00018,4.00018,0,0,1-4,4h-4v12A4.00018,4.00018,0,0,1,125,176.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173,176.4922H149a4,4,0,0,1,0-8h24a4,4,0,0,1,0,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157,176.4922a4.00018,4.00018,0,0,1-4-4v-16a4,4,0,0,1,8,0v16A4.00018,4.00018,0,0,1,157,176.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173,152.5078a4.00018,4.00018,0,0,1-4-4V136.4922H149a4,4,0,0,1,0-8h24a4.00018,4.00018,0,0,1,4,4v16.0156A4.00018,4.00018,0,0,1,173,152.5078Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173,120.4922h-8a4,4,0,0,1,0-8h4v-12a4,4,0,0,1,8,0v16A4.00018,4.00018,0,0,1,173,120.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133,136.4922h-8a4,4,0,0,1,0-8h4v-12a4.00018,4.00018,0,0,1,4-4h12v-20a4.00018,4.00018,0,0,1,4-4h8a4,4,0,0,1,0,8h-4v20a4.00018,4.00018,0,0,1-4,4H137v12A4.00018,4.00018,0,0,1,133,136.4922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93,120.4922H77a4,4,0,0,1,0-8H93a4,4,0,0,1,0,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37,104.4922a4.00018,4.00018,0,0,1-4-4v-8a4,4,0,0,1,8,0v8A4.00018,4.00018,0,0,1,37,104.4922Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQr);
export default __webpack_public_path__ + "static/media/icon_qr.f973564f144914894889e820274ffd50.svg";
export { ForwardRef as ReactComponent };